import React, {
  memo, useEffect, useRef, useState,
} from 'react';
import { createUseStyles } from 'react-jss';

interface SenderProps {
  label: string,
  text: string,
  colors: {
    label: string,
    text: string,
  }
}

const Sender: React.FC<SenderProps> = (props) => {
  const {
    label,
    text,
    colors,
  } = props;

  const classes = useStyles();

  const fromRef = useRef<HTMLDivElement | null>(null);

  const [textFinal, setTextFinal] = useState(text);

  useEffect(() => {
    const element = fromRef.current as HTMLDivElement;
    const parent = (fromRef.current as HTMLDivElement).parentNode as HTMLDivElement;

    element.textContent = text;
    if (element.clientWidth <= parent.clientWidth) {
      setTextFinal(text);
      return;
    }
    while (element.clientWidth > parent.clientWidth) {
      element.textContent = element.textContent.substring(0, element.textContent.length - 1);
    }
    if (element.textContent === text) {
      setTextFinal(text);
      return;
    }
    setTextFinal(`${element.textContent.substring(0, element.textContent.length - 2)}...`);
  }, [text]);

  return (
    <div className={classes.sender}>
      <div className="label" style={{ color: colors.label }}>{label}</div>
      <div className="container">
        <div className="text" style={{ color: colors.text }}>{textFinal}</div>
        <div className="textTest"><div ref={fromRef} /></div>
      </div>
    </div>
  );
};

const useStyles = createUseStyles({
  sender: {
    '&': {
      zIndex: 2,
      marginTop: '19.4rem',
    },
    '& div': {
      fontFamily: '"Avenir Next Demi", sans-serif',
      textAlign: 'center',
    },
    '& div.container': {
      margin: '1rem auto 0',
      width: '25rem',
      overflow: 'hidden',
      justifyContent: 'center',
    },
    '& div.label': {
      fontSize: '1.4rem',
      color: '#3F3F3F',
    },
    '& div.text': {
      fontSize: '2.3rem',
      color: '#3F3F3F',
    },
    '& div.textTest': {
      '&': {
        position: 'relative',
        pointerEvents: 'none',
        userSelect: 'none',
        height: 0,
        fontSize: '2.3rem',
        overflow: 'hidden',
      },
      '& > div': {
        position: 'absolute',
      },
    },
  },
});

export default memo(Sender);
